import React from 'react';
import classNames from 'classnames';
import { formatCoursePrice } from '../../../../utilities';
import { scribbleArrowRightImage } from '../../../../assets';
import AnyCourse from './any-course';
import { t } from '../../../../../i18n';
import './styles.scss';

const GiftCardPreviewDesktop = ({ className, price, coursesStats }) => (
  <section className={classNames('courses-gift-card-preview-desktop', className)}>
    <div className="courses-gift-card-preview-desktop__cards">
      <div className="courses-gift-card-preview-desktop__card">
        <h2 className="courses-gift-card-preview-desktop__card-title">
          {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD')}
        </h2>
        <p className="courses-gift-card-preview-desktop__card-description">
          {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.BUY_PART_1')}
          {price ? (
            <strong className="courses-gift-card-preview-desktop__price">{` ${formatCoursePrice(price)} `}</strong>
          ) : (
            <strong className="courses-gift-card-preview-desktop__price-placeholder placeholder-glow">
              <span className="placeholder" />
            </strong>
          )}
          {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.BUY_PART_2')}
        </p>
        <p className="courses-gift-card-preview-desktop__remark" />
      </div>
      <img
        src={scribbleArrowRightImage}
        alt="Arrow right"
        className="courses-gift-card-preview-desktop__arrow-right courses-gift-card-preview-desktop__arrow-right--upper"
      />
      <div className="courses-gift-card-preview-desktop__card">
        <h2 className="courses-gift-card-preview-desktop__card-title">
          {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.ACTIVATE_CODE')}
        </h2>
        <p className="courses-gift-card-preview-desktop__card-description">
          {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.ACTIVATION_INSTRUCTIONS')}
        </p>
        <p className="courses-gift-card-preview-desktop__remark">{t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.REMARK')}</p>
      </div>
      <img
        src={scribbleArrowRightImage}
        alt="Arrow right"
        className="courses-gift-card-preview-desktop__arrow-right courses-gift-card-preview-desktop__arrow-right--lower"
      />
      <div className="courses-gift-card-preview-desktop__courses">
        <AnyCourse.Card className="courses-gift-card-preview-desktop__course courses-gift-card-preview-desktop__course--empty" />
        <AnyCourse.Card className="courses-gift-card-preview-desktop__course courses-gift-card-preview-desktop__course--empty" />
        {coursesStats ? (
          <AnyCourse
            courses={coursesStats.courses}
            lessonsCount={coursesStats.lessonsCount}
            oldPrice={price}
            className="courses-gift-card-preview-desktop__course"
          />
        ) : (
          <AnyCourse.Placeholder className="courses-gift-card-preview-desktop__course" />
        )}
      </div>
    </div>
  </section>
);

export default GiftCardPreviewDesktop;
